import { FETCH_TICKETS } from "../constants/tickets";
import { Action, TicketsState } from "../models/tickets";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils";

function data(
  state: TicketsState = {
    data: {
      count: 0,
      currentPage: 0,
      pageCount: 0,
      perPage: 0,
      ticketItems: [],
    },
    error: null,
    isFetching: false,
  },
  action: Action
): TicketsState {
  const edited: any = {};
  if (action.type === getSuccessActionType(FETCH_TICKETS)) {
    const allData = { ...action.payload };

    for (const key in allData) {
      if (key === "data") {
        edited.ticketItems = allData[key];
      } else {
        edited[key] = allData[key];
      }
    }
  }

  switch (action.type) {
    case getSuccessActionType(FETCH_TICKETS):
      return { ...state, data: edited, isFetching: false, error: null };
    case getFailureActionType(FETCH_TICKETS):
      return { ...state, error: action.payload, isFetching: false };
    case getRequestActionType(FETCH_TICKETS):
      return { ...state, isFetching: true };
    default:
      return state;
  }
}

export default data;
